export const translations = {
    en: {
      nav: {
        features: "Features",
        pricing: "Pricing",
        setup: "Setup",
        getStarted: "Get Started"
      },
      hero: {
        title: "AI Chat for Every Website",
        subtitle: "Enhance your website with an intelligent AI assistant. Easy setup, powerful conversations, seamless integration.",
        cta: "Start Free Trial"
      },
      setup: {
        title: "Setup in Three Simple Steps",
        steps: [
          {
            title: "1. Register & Analyze",
            description: "Register your account and let our AI analyze your website content"
          },
          {
            title: "2. Customize",
            description: "Configure your AI assistant's behavior and appearance"
          },
          {
            title: "3. Embed",
            description: "Add the code snippet to your website and go live"
          }
        ]
      },
      pricing: {
        title: "Choose Your Plan",
        plans: {
          starter: {
            name: "Starter",
            price: "0 €",
            features: ["10 conversations/month", "Basic customization"]
          },
          startup: {
            name: "Startup",
            price: "25 €",
            features: ["50 conversations/month", "Advanced customization", "Priority support"]
          },
          business: {
            name: "Small Business",
            price: "60 €",
            features: ["150 conversations/month", "Full customization", "24/7 support"]
          },
          enterprise: {
            name: "Enterprise",
            price: "Custom",
            features: ["Unlimited conversations", "Custom integration", "Dedicated support"]
          }
        },
        month: "/month",
        contactSales: "Contact Sales",
        choosePlan: "Choose Plan"
      },
      footer: {
        description: "AI-powered chat solution for modern websites",
        product: "Product",
        company: "Company",
        legal: "Legal",
        rights: "All rights reserved."
      }
    },
    de: {
      nav: {
        features: "Funktionen",
        pricing: "Preise",
        setup: "Einrichtung",
        getStarted: "Loslegen"
      },
      hero: {
        title: "KI-Chat für jede Website",
        subtitle: "Erweitern Sie Ihre Website mit einem intelligenten KI-Assistenten. Einfache Einrichtung, leistungsstarke Gespräche, nahtlose Integration.",
        cta: "Kostenlos testen"
      },
      setup: {
        title: "Einrichtung in drei einfachen Schritten",
        steps: [
          {
            title: "1. Registrieren & Analysieren",
            description: "Registrieren Sie Ihr Konto und lassen Sie unsere KI Ihre Website-Inhalte analysieren"
          },
          {
            title: "2. Anpassen",
            description: "Konfigurieren Sie das Verhalten und Aussehen Ihres KI-Assistenten"
          },
          {
            title: "3. Einbetten",
            description: "Fügen Sie den Code-Snippet in Ihre Website ein und gehen Sie live"
          }
        ]
      },
      pricing: {
        title: "Wählen Sie Ihren Plan",
        plans: {
          starter: {
            name: "Starter",
            price: "0 €",
            features: ["10 Gespräche/Monat", "Basis-Anpassung"]
          },
          startup: {
            name: "Startup",
            price: "25 €",
            features: ["50 Gespräche/Monat", "Erweiterte Anpassung", "Prioritäts-Support"]
          },
          business: {
            name: "Kleinunternehmen",
            price: "60 €",
            features: ["150 Gespräche/Monat", "Volle Anpassung", "24/7 Support"]
          },
          enterprise: {
            name: "Enterprise",
            price: "Individuell",
            features: ["Unbegrenzte Gespräche", "Individuelle Integration", "Dedizierter Support"]
          }
        },
        month: "/Monat",
        contactSales: "Vertrieb kontaktieren",
        choosePlan: "Plan wählen"
      },
      footer: {
        description: "KI-gestützte Chat-Lösung für moderne Websites",
        product: "Produkt",
        company: "Unternehmen",
        legal: "Rechtliches",
        rights: "Alle Rechte vorbehalten."
      }
    },
    fr: {
      nav: {
        features: "Fonctionnalités",
        pricing: "Tarifs",
        setup: "Installation",
        getStarted: "Commencer"
      },
      hero: {
        title: "Chat IA pour Chaque Site Web",
        subtitle: "Améliorez votre site web avec un assistant IA intelligent. Installation facile, conversations puissantes, intégration transparente.",
        cta: "Essai Gratuit"
      },
      setup: {
        title: "Installation en Trois Étapes Simples",
        steps: [
          {
            title: "1. Inscription & Analyse",
            description: "Inscrivez-vous et laissez notre IA analyser le contenu de votre site"
          },
          {
            title: "2. Personnalisation",
            description: "Configurez le comportement et l'apparence de votre assistant IA"
          },
          {
            title: "3. Intégration",
            description: "Ajoutez le code sur votre site et lancez-vous"
          }
        ]
      },
      pricing: {
        title: "Choisissez Votre Plan",
        plans: {
          starter: {
            name: "Débutant",
            price: "0 €",
            features: ["10 conversations/mois", "Personnalisation basique"]
          },
          startup: {
            name: "Startup",
            price: "25 €",
            features: ["50 conversations/mois", "Personnalisation avancée", "Support prioritaire"]
          },
          business: {
            name: "Petite Entreprise",
            price: "60 €",
            features: ["150 conversations/mois", "Personnalisation complète", "Support 24/7"]
          },
          enterprise: {
            name: "Entreprise",
            price: "Sur mesure",
            features: ["Conversations illimitées", "Intégration personnalisée", "Support dédié"]
          }
        },
        month: "/mois",
        contactSales: "Contacter les ventes",
        choosePlan: "Choisir ce plan"
      },
      footer: {
        description: "Solution de chat IA pour sites web modernes",
        product: "Produit",
        company: "Entreprise",
        legal: "Légal",
        rights: "Tous droits réservés."
      }
    },
    bg: {
      nav: {
        features: "Функции",
        pricing: "Цени",
        setup: "Настройка",
        getStarted: "Започнете"
      },
      hero: {
        title: "AI Чат за Всеки Сайт",
        subtitle: "Подобрете вашия уебсайт с интелигентен AI асистент. Лесна настройка, мощни разговори, безпроблемна интеграция.",
        cta: "Безплатен Пробен Период"
      },
      setup: {
        title: "Настройка в Три Прости Стъпки",
        steps: [
          {
            title: "1. Регистрация и Анализ",
            description: "Регистрирайте се и оставете нашия AI да анализира съдържанието на вашия сайт"
          },
          {
            title: "2. Персонализиране",
            description: "Конфигурирайте поведението и външния вид на вашия AI асистент"
          },
          {
            title: "3. Вграждане",
            description: "Добавете кода към вашия сайт и стартирайте"
          }
        ]
      },
      pricing: {
        title: "Изберете Вашия План",
        plans: {
          starter: {
            name: "Стартов",
            price: "0 €",
            features: ["10 разговора/месец", "Основна персонализация"]
          },
          startup: {
            name: "Стартъп",
            price: "25 €",
            features: ["50 разговора/месец", "Разширена персонализация", "Приоритетна поддръжка"]
          },
          business: {
            name: "Малък Бизнес",
            price: "60 €",
            features: ["150 разговора/месец", "Пълна персонализация", "24/7 поддръжка"]
          },
          enterprise: {
            name: "Корпоративен",
            price: "По запитване",
            features: ["Неограничени разговори", "Персонализирана интеграция", "Dedicated поддръжка"]
          }
        },
        month: "/месец",
        contactSales: "Свържете се с продажби",
        choosePlan: "Изберете план"
      },
      footer: {
        description: "AI чат решение за модерни уебсайтове",
        product: "Продукт",
        company: "Компания",
        legal: "Правни",
        rights: "Всички права запазени."
      }
    },
    ro: {
      nav: {
        features: "Funcții",
        pricing: "Prețuri",
        setup: "Configurare",
        getStarted: "Începeți"
      },
      hero: {
        title: "Chat AI pentru Fiecare Site Web",
        subtitle: "Îmbunătățiți-vă site-ul web cu un asistent AI inteligent. Configurare ușoară, conversații puternice, integrare perfectă.",
        cta: "Încercați Gratuit"
      },
      setup: {
        title: "Configurare în Trei Pași Simpli",
        steps: [
          {
            title: "1. Înregistrare și Analiză",
            description: "Înregistrați-vă și lăsați AI-ul nostru să analizeze conținutul site-ului dvs."
          },
          {
            title: "2. Personalizare",
            description: "Configurați comportamentul și aspectul asistentului AI"
          },
          {
            title: "3. Integrare",
            description: "Adăugați codul în site-ul dvs. și lansați"
          }
        ]
      },
      pricing: {
        title: "Alegeți Planul Dvs.",
        plans: {
          starter: {
            name: "Starter",
            price: "0 €",
            features: ["10 conversații/lună", "Personalizare de bază"]
          },
          startup: {
            name: "Startup",
            price: "25 €",
            features: ["50 conversații/lună", "Personalizare avansată", "Suport prioritar"]
          },
          business: {
            name: "Business Mic",
            price: "60 €",
            features: ["150 conversații/lună", "Personalizare completă", "Suport 24/7"]
          },
          enterprise: {
            name: "Enterprise",
            price: "La cerere",
            features: ["Conversații nelimitate", "Integrare personalizată", "Suport dedicat"]
          }
        },
        month: "/lună",
        contactSales: "Contactați vânzările",
        choosePlan: "Alegeți planul"
      },
      footer: {
        description: "Soluție de chat AI pentru site-uri web moderne",
        product: "Produs",
        company: "Companie",
        legal: "Legal",
        rights: "Toate drepturile rezervate."
      }
    }
  };
  